export default __webpack_public_path__ + "static/media/7.8d384da4.jpg";